module.exports = __webpack_public_path__ + "media/images/responsive/articles/icon_share-db0883fd6e074c1fe9260374b7ea8063.svg";